import { callRpc } from '@/services/juntasRpc'

export async function getMyOrganizations() {
  const data = await callRpc('get_my_organizations')
  return Array.isArray(data) ? data : []
}

export async function getAssociationMetricsLive(orgId, cohortLabel = null, since = null) {
  return callRpc('get_association_metrics_live', {
    p_organization_id: orgId,
    p_cohort_label: cohortLabel,
    p_since: since,
  })
}

export async function listMyOrgCodes(orgId) {
  const data = await callRpc('list_my_org_codes', { p_organization_id: orgId })
  return Array.isArray(data) ? data : []
}

export async function issueInvitationCode(orgId, cohortLabel = null, maxUses = 30, validityDays = 90) {
  return callRpc('issue_invitation_code', {
    p_organization_id: orgId,
    p_cohort_label: cohortLabel,
    p_max_uses: maxUses,
    p_validity_days: validityDays,
  })
}

export async function revokeOrgCode(codeId) {
  return callRpc('revoke_org_code', { p_code_id: codeId })
}

export async function generateAssociationReport(orgId, periodStart, periodEnd, cohortLabel = null) {
  return callRpc('generate_association_report', {
    p_organization_id: orgId,
    p_period_start: periodStart,
    p_period_end: periodEnd,
    p_cohort_label: cohortLabel,
  })
}
